<template>
  <!-- 月/季度/年度目标列表 -->
  <div class="goal-detail-list" v-loading="loading" element-loading-text="加载中...">
    <!-- 有数据时显示表格 -->
    <div v-if="tableData && tableData.length > 0" class="table-area">
      <CustomTable
        :tableData="pagedData"
        :column="columns"
        border
        max-height="500"
        class="detail-table"
        :header-cell-style="headerCellStyle"
      >
        <template slot="indexCell" slot-scope="{ index }">
          <span>{{ index + 1 }}</span>
        </template>
        <template slot="monthSaleCell" slot-scope="{ row }">
          <span>{{ row.monthSale || 0 }}万</span>
        </template>
        <template slot="approverCell" slot-scope="{ row }">
          <span>{{ (row.auditerName || []).join('、') }}</span>
        </template>
        <template slot="starCell" slot-scope="{ row }">
          <CustomStarText :saleStar="row.saleStar" :avgStar="row.avgStar" />
        </template>
      </CustomTable>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageInfo.total"
          :page-size="pageInfo.pageSize"
          :current-page.sync="pageInfo.pageNum"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

    <!-- 空数据状态 -->
    <div v-else class="empty-state">
      <el-empty :description="emptyText"></el-empty>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
let allTableData = []
export default {
  name: 'GoalDetailList',
  props: {
    // 周期类型：1-年度,2-季度,3-月度
    period: {
      type: [String, Number],
      default: '1'
    },
    // 月份：1-12
    month: {
      type: [String, Number],
      default: '1' // 默认1月
    },
    groupInfoId: {
      type: [String, Number],
      default: ''
    },
    workNumber: {
      type: [String, Number],
      default: ''
    },
    // 销售星级
    saleStar: {
      type: [String, Number],
      default: ''
    },
    // 空状态提示文字
    emptyText: {
      type: String,
      default: '暂无签约医生'
    }
  },
  data() {
    return {
      loading: false,
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      tableData: [],
      columns: [
        { label: '', minWidth: '60', align: 'center', slotName: 'indexCell' },
        { prop: 'doctorName', label: '医生', minWidth: '90', align: 'left' },
        { prop: 'star', label: '星级', minWidth: '100', align: 'left', slotName: 'starCell' },
        { prop: 'monthSale', label: '月销售额', minWidth: '90', align: 'left', slotName: 'monthSaleCell' },
        { prop: 'avgVisitNum', label: '次均门诊量', minWidth: '100', align: 'right' },
        { prop: 'approverText', label: '审批人', minWidth: '150', align: 'left', slotName: 'approverCell' },
        { prop: 'signDate', label: '签约日期', minWidth: '110', align: 'left' },
        { prop: 'firstDate', label: '首次坐诊日期', minWidth: '110', align: 'left' },
        // { prop: 'signPeriod', label: '签约周期', minWidth: '90', align: 'left' }, // todo:
        { prop: 'groupName', label: '团队', minWidth: '110', align: 'left' },
        { prop: 'followerWorkName', label: '跟进人', minWidth: '100', align: 'left' }
      ]
    }
  },
  computed: {
    // 后端分页模式下，直接返回 tableData
    pagedData() {
      return this.tableData
    }
  },
  mounted() {
    // 组件挂载时自动请求数据
    this.getTableData()
  },
  methods: {
    headerCellStyle() {
      return { background: '#F7F8F9', color: '#667182', fontWeight: 500 }
    },
    // 获取目标详情数据
    async getTableData() {
      this.loading = true
      try {
        const params = {
          month: this.month || '',
          quarter: Math.ceil(this.month / 3) || '',
          year: new Date().getFullYear(),
          saleStar: this.saleStar || '',
          period: this.period || '',
          ...this.groupInfoId && {
            groupInfoId: this.groupInfoId || ''
          },
          ...this.workNumber && {
            workNumber: this.workNumber || ''
          }
        }
        
        // 调用真实接口
        const res = await request.get('/cluepool/pc/admin/dashboard/target/doctor/detail', params, '')
        
        if (res.code === 200) {
          this.pageInfo.pageNum = 1
          allTableData = (res.data || []).map((item, index) => ({
            ...item,
            signDate: item.signTime ? new Date(item.signTime).Format('yyyy-MM-dd') : '',
            firstDate: item.firstDate ? new Date(item.firstDate).Format('yyyy-MM-dd') : ''
          }))
          this.pageInfo.total = allTableData.length || 0
          this.getResultTableData()
        } else {
          this.$message.error(res.message || '获取数据失败')
          this.tableData = []
          this.pageInfo.total = 0
        }
      } catch (error) {
        console.error('获取目标详情数据失败:', error)
        this.$message.error('获取数据失败，请稍后重试')
        this.tableData = []
        this.pageInfo.total = 0
      } finally {
        this.loading = false
      }
    },

    getResultTableData() {
      this.tableData = allTableData.slice((this.pageInfo.pageNum - 1) * this.pageInfo.pageSize, this.pageInfo.pageNum * this.pageInfo.pageSize)
    },

    handlePageChange(page) {
      this.pageInfo.pageNum = page
      this.getResultTableData()
    }
  },
  components: {
    CustomStarText: () => import('@/views/DoctorVisitLTC/components/customStarText/CustomStarText.vue'),
    CustomTable: () => import('@/components/CustomTable.vue')
  }
}
</script>

<style scoped lang="less">
.goal-detail-list {
  .table-area {
    padding: 20px 24px;

    .detail-table {
      /deep/ .el-table {
        font-size: 13px;
        color: #1F2329;
        border-color: #EBEAEE;

        &::before,
        &::after {
          background-color: #EBEAEE;
        }

        th {
          padding: 0 !important;
          height: 40px;
        }

        td {
          padding: 0 !important;
          height: 44px;
        }

        .cell {
          line-height: 20px;
        }
      }

      /deep/ .el-tag--plain.el-tag--info {
        background-color: #F7F8F9;
        border-color: #EBEAEE;
        color: #667182;
        height: 24px;
        line-height: 22px;
        padding: 0 10px;
        border-radius: 12px;
        font-size: 12px;
      }
    }

    .pagination-wrap {
      display: flex;
      justify-content: flex-end;
      margin-top: 16px;
    }
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;

    /deep/ .el-empty__description p {
      font-size: 14px;
      color: #9AA0A8;
    }
  }
}
</style>
